import React, { useState } from 'react';
import classNames from 'classnames';

import { randomString } from '../../utils';

import s from './Stars.sss';

interface Props {
  value: number,
  count?: number,
  readOnly?: boolean,
  className?: string,
  width?: string | number,
  height?: string | number,
  gap?: number,
  onClick?: (index: number) => void,
}

export const Stars: React.FC<Props> = ({
  value,
  count = 5,
  readOnly,
  className,
  width = 16,
  height = 16,
  gap = 4,
  onClick,
}) => {
  const [index, setIndex] = useState<number | null>(value);
  let v = index || value;

  return (
    <ul
      className={classNames(
        s.list,
        className,
      )}
      style={{
        margin: `0 -${gap / 2}px`,
      }}
    >
      {[...Array(count)].map((_, i: number) => {
        const randomId = randomString(5);
        let starFill = '0%';
        if (v > 0) {
          starFill = v > 1 ? '100%' : `${Math.trunc(v * 100)}%`;
          v -= 1;
        }
        return (
          <li
            key={i}
            className={s.item}
            style={{
              padding: `0 ${gap / 2}px`,
            }}
            onMouseEnter={() => (readOnly ? null : setIndex(i + 1))}
            onMouseLeave={() => (readOnly ? null : setIndex(null))}
            onClick={() => (onClick ? onClick(i + 1) : null)}
          >
            <svg
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              className={classNames(
                s.icon,
                {
                  [s.iconTypeReadonly]: readOnly,
                },
              )}
              width={width}
              height={height}
            >
              <defs>
                <linearGradient id={`${index}-${randomId}half_grad`}>
                  <stop offset={starFill} stopColor="#FFA000" />
                  <stop offset="0%" stopColor="#d2d2d2" />
                </linearGradient>
              </defs>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.6171 14.1947C11.4838 14.1947 11.3525 14.1621 11.2331 14.0994L7.99981 12.4121L4.76381 14.1007C4.60781 14.1834 4.42314 14.2121 4.24714 14.1841C3.80114 14.1081 3.49981 13.6834 3.57514 13.2361L4.16714 9.61008L1.57514 7.02608C1.45181 6.90275 1.36981 6.74075 1.34314 6.56875C1.27381 6.12075 1.57981 5.69941 2.02581 5.62941L5.63248 5.07408L7.26714 1.78875C7.34714 1.63008 7.47581 1.50008 7.63248 1.42141C7.82514 1.32408 8.04714 1.30541 8.25581 1.37541C8.46448 1.44408 8.63381 1.59075 8.73181 1.78875L10.3671 5.07408L13.9731 5.62941C14.1465 5.65675 14.3085 5.74008 14.4305 5.86408C14.7465 6.18608 14.7438 6.70741 14.4245 7.02541L11.8325 9.61008L12.4251 13.2381C12.4845 13.7221 12.1651 14.1334 11.7178 14.1894H11.7158C11.6825 14.1927 11.6498 14.1947 11.6171 14.1947Z"
                fill={`url(#${index}-${randomId}half_grad)`}
              />
            </svg>
          </li>
        );
      })}
    </ul>
  );
};
